import { render, staticRenderFns } from "./StudyPolicyList.vue?vue&type=template&id=788e9649&scoped=true&"
import script from "./StudyPolicyList.vue?vue&type=script&lang=js&"
export * from "./StudyPolicyList.vue?vue&type=script&lang=js&"
import style0 from "./StudyPolicyList.vue?vue&type=style&index=0&id=788e9649&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788e9649",
  null
  
)

export default component.exports